import { RouteWithoutLayout } from "ra-core";
import * as React from "react";
import { Route } from 'react-router-dom';
import FileExplorer from "./file-explorer/FileExplorer";
import SharedFile from "./file/SharedFile";
import { getAuthenticationRoutes } from "@develnet/authentication";

export default [
    <Route path="/file-explorer" component={FileExplorer} exact/>,
    <Route path="/file-explorer/:path+" component={FileExplorer} exact/>,
    <RouteWithoutLayout path="/shared-resource/:accessor" component={SharedFile} exact/>,
].concat(getAuthenticationRoutes());
